import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import BaseAppBar from 'components/AppBar/BaseAppBar';

const AppBar = props => {
  const { ownState, logo, name, logoLinkPath, children } = props;
  return (
    <BaseAppBar
      ownState={ownState}
      logo={logo}
      name={name}
      logoLinkPath={logoLinkPath}
    >
      <Box display="flex" justifyContent="flex-end">
        {children}
      </Box>
    </BaseAppBar>
  );
};

AppBar.propTypes = {
  children: PropTypes.node,
  logo: PropTypes.string,
  name: PropTypes.string,
  logoLinkPath: PropTypes.string,
  ownState: PropTypes.object
};

export default React.memo(AppBar);
